import { z } from "@/zod";
import {
  bankAccountNumber,
  dateTime,
  nonNegativeDecimalStringSchema,
  ulid,
} from "./commonFields";
import { taxStatus } from "./commonFields/taxStatus";
import { applyEmptyStringsToNulls } from "@/lib/utils/zod";
import { AGREEMENT_STATUS } from "@/types/agreement";

export const payrollSplit = z
  .object({
    id: ulid,
    payroll_id: ulid,
    period: z.string().date(),
    contractor_id: ulid,
    contractor: z.string(),
    tax_status_final: taxStatus,
    agreement_status_current: z.enum(AGREEMENT_STATUS),
    agreement_company_id: ulid,
    agreement_company: z.string(),
    amount_to_pay: nonNegativeDecimalStringSchema.nullable(),
    amount_agreement1: nonNegativeDecimalStringSchema.nullable(),
    contest1: nonNegativeDecimalStringSchema.nullable(),
    contest2: nonNegativeDecimalStringSchema.nullable(),
    contest3: nonNegativeDecimalStringSchema.nullable(),
    contest4: nonNegativeDecimalStringSchema.nullable(),
    contest5: nonNegativeDecimalStringSchema.nullable(),
    contest6: nonNegativeDecimalStringSchema.nullable(),
    contest7: nonNegativeDecimalStringSchema.nullable(),
    total_contests: nonNegativeDecimalStringSchema,
    amount_agreement2: nonNegativeDecimalStringSchema.nullable(),
    block_agreement2: z.boolean(),
    block_contests: z.boolean(),
    contest_survey_uploaded: z.boolean(),
    agreement2_sent_at: dateTime,
    agreement2_sign_date: dateTime,
    bank_account_number: bankAccountNumber,
    comment: z.coerce.string().nullable(),
    permanent_comment: z.coerce.string().nullable(),
    citizenship: z.string(),
    personal_id_number: z.string(),
  })
  .readonly();

export const updatePayrollSplits = applyEmptyStringsToNulls({
  id: ulid,
  amount_to_pay: nonNegativeDecimalStringSchema.nullable(),
  amount_agreement1: nonNegativeDecimalStringSchema.nullable(),
  amount_agreement2: nonNegativeDecimalStringSchema.nullable(),
  contest1: nonNegativeDecimalStringSchema.nullable(),
  contest2: nonNegativeDecimalStringSchema.nullable(),
  contest3: nonNegativeDecimalStringSchema.nullable(),
  contest4: nonNegativeDecimalStringSchema.nullable(),
  contest5: nonNegativeDecimalStringSchema.nullable(),
  contest6: nonNegativeDecimalStringSchema.nullable(),
  contest7: nonNegativeDecimalStringSchema.nullable(),
  comment: z.coerce.string().nullable(),
});
